<template>
  <div>
    <!-- Basic Details -->
    <basic-details
      :matter="$store.state.matterStore.currentmatter"
    ></basic-details>
    <!-- Case Status -->
    <div v-if="hasCaseDetails">
      <district-case-status
        :matter="$store.state.matterStore.currentmatter"
        :detail="$store.state.matterStore.currentmatter.case_details"
      ></district-case-status>
    </div>
    <!-- Acts -->
    <div v-if="hasActs">
      <act-details
        :matter="$store.state.matterStore.currentmatter"
      ></act-details>
    </div>
    <!-- Linked Matters -->
    <div v-if="hasLinkedMatters">
      <linked-matters
        :matter="$store.state.matterStore.currentmatter"
      ></linked-matters>
    </div>
    <!-- FIR Details -->
    <div v-if="hasCrimeDic">
      <f-i-r-details
        :matter="$store.state.matterStore.currentmatter"
        :detail="$store.state.matterStore.currentmatter.case_details"
      ></f-i-r-details>
    </div>
    <!-- Peitioner & Respondent -->
    <div
    >
      <petitioner-respondents
        :matter="$store.state.matterStore.currentmatter"
      ></petitioner-respondents>
    </div>
    <!-- Listening History -->
    <div v-if="hasListingHistory">
      <listing-details
        :matter="$store.state.matterStore.currentmatter"
      ></listing-details>
    </div>
    <!-- Transfer History -->
    <div v-if="hasTransferHistory">
      <transfer-history
        :matter="$store.state.matterStore.currentmatter"
      ></transfer-history>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
// Section Imports
import BasicDetails from './components/basic-details/BasicDetails.vue'
import DistrictCaseStatus from './components/status/DistrictCaseStatus.vue'
import ListingDetails from './components/listing-history/ListingDetails.vue'
import PetitionerRespondents from './components/petitioner-respondent/PetitionerRespondents.vue'
import LinkedMatters from './components/LinkedMatters.vue'
import ActDetails from './components/ActDetails.vue'
import TransferHistory from './components/TransferHistory.vue'
import FIRDetails from './components/FIRDetails.vue'

export default {
  computed: {
    currentMatter() {
      return this.$store.state.matterStore.currentmatter || {}
    },
    hasCaseDetails() {
      return this.hasAnyData(this.currentMatter.case_details)
    },
    hasActs() {
      return this.hasAnyData(this.currentMatter.acts)
    },
    hasLinkedMatters() {
      return this.hasAnyData(this.currentMatter.linked_matters)
    },
    hasCrimeDic() {
      return this.hasAnyData(this.currentMatter.crime_dic)
    },
    hasListingHistory() {
      return this.hasAnyData(this.currentMatter.listing_history)
    },
    hasTransferHistory() {
      return this.hasAnyData(this.currentMatter.transfer_history)
    }
  },
  methods: {
    hasAnyData(value) {
      if (Array.isArray(value)) return value.length > 0
      if (value && typeof value === 'object') return Object.keys(value).length > 0
      return value !== null && value !== undefined && value !== ''
    }
  },
  components: {
    BRow,
    BCol,
    // Basic Details
    BasicDetails,
    DistrictCaseStatus,
    ListingDetails,
    PetitionerRespondents,
    LinkedMatters,
    ActDetails,
    TransferHistory,
    FIRDetails
  }
}
</script>
